import { render, staticRenderFns } from "./MobAssessmentMarks.vue?vue&type=template&id=0402e0d0&scoped=true"
import script from "./MobAssessmentMarks.vue?vue&type=script&lang=js"
export * from "./MobAssessmentMarks.vue?vue&type=script&lang=js"
import style0 from "./MobAssessmentMarks.vue?vue&type=style&index=0&id=0402e0d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0402e0d0",
  null
  
)

export default component.exports